import React from "react"
import NCALayerComponent from "../components/NCALayerComponent"

export default class NCALayerPage extends React.Component {
  state = {}
  render() {
    return (
      <>
        <div>
          <NCALayerComponent />
        </div>
      </>
    )
  }
}
